import FieldSet from '../../FieldSet';
import { TimeTracking } from './TimeTracking';
import { TimeTrackingWithIcon } from './TimeTrackingWithIcon';

export class TimeTrackingFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [TimeTracking, TimeTrackingWithIcon];
  }

  get title() {
    return 'Best estimate';
  }
}
